import { getLoginModalInstance } from '../../application/login_modal';

const linkTextClasses = { liked: '.js-review-assessment__like-text', disliked: '.js-review-assessment__dislike-text' };
const linkClasses = { liked: '.js-review-assessment__like-link', disliked: '.js-review-assessment__dislike-link' };

class ActionLink {
  constructor($element, action) {
    this.$element = $element;
    this.action = action;
  }

  findCounterEl() {
    return this.$element.find(linkTextClasses[this.action]);
  }

  decrementCount() {
    let newCount;
    const $counterText = this.findCounterEl();
    const text = $counterText.text();
    const result = text.match(/\d{1,}/);
    const count = parseInt(result[0], 10);
    if (count - 1 === 0) {
      newCount = text.replace(/ \(\d{1,}\)/, '');
    } else {
      newCount = text.replace(/\d{1,}/, count - 1);
    }

    $counterText.text(newCount);

    return this;
  }

  incrementCount() {
    let newCount;
    const $counterText = this.findCounterEl();
    const text = $counterText.text();
    const result = text.match(/\d{1,}/);

    if (result === null) {
      newCount = `${text} (1)`;
    } else {
      const count = parseInt(result[0], 10);
      newCount = text.replace(/\d{1,}/, count + 1);
    }

    $counterText.text(newCount);

    return this;
  }

  isActive() {
    return this.$element.hasClass('review-assessment__link--active');
  }

  inactivate() {
    this.$element.removeClass('review-assessment__link--active');
  }

  activate() {
    this.$element.addClass('review-assessment__link--active');
  }

  isLike() {
    return this.action === 'liked';
  }
}

class ReviewAssessment {
  initListeners() {
    const $document = $(document);
    $document.on('click', linkClasses.liked, event => this.onClick('liked', event));
    $document.on('click', linkClasses.disliked, event => this.onClick('disliked', event));
  }

  onClick(rating, event) {
    event.preventDefault();

    this.actionLink = new ActionLink($(event.currentTarget), rating);
    this.$reviewAssessmentComponent = this.actionLink.$element.closest('.js-review-assessment');
    const userIsSignedIn = this.$reviewAssessmentComponent.data('user-signed-in');

    if (userIsSignedIn) {
      this.callAction();
      this.updateUI();
    } else {
      getLoginModalInstance().show({
        onSuccess: () => {
          this.callAction(() => window.location.reload());
        },
      });
    }
  }

  updateUI() {
    let otherActionLink;

    if (this.actionLink.isLike()) {
      otherActionLink = new ActionLink(
        this.$reviewAssessmentComponent.find(linkClasses.disliked),
        'disliked',
      );
    } else {
      otherActionLink = new ActionLink(
        this.$reviewAssessmentComponent.find(linkClasses.liked),
        'liked',
      );
    }

    if (this.actionLink.isActive()) {
      this.actionLink.decrementCount().inactivate();
    } else {
      this.actionLink.incrementCount().activate();
    }

    if (otherActionLink.isActive()) {
      otherActionLink.decrementCount().inactivate();
    }
  }

  callAction(callback) {
    const done = callback || $.noop;
    $.post(this.actionLink.$element.attr('data-url')).done(done);
  }
}

const reviewAssessment = new ReviewAssessment();

reviewAssessment.initListeners();
